<template>

  <div class="">
    <div id="FullScreenOverlay" class="overlay">
      <span class="closebtn" @click="closeSearchHero()" title="Close Overlay">×</span>
      <div class="overlay-content text-center">
        <form @submit.prevent="search">
          <b-row align-h="center">
            <input v-model="words" type="text" required
                   class="my-1 custom-height rounded-pill col-lg-8 col-sm-8 col-md-8 form-control"
                   placeholder="جست وجو"
                   name="search">
            <select v-model="type"
                    class="my-1 text-center custom-height custom-select rounded-pill col-lg-3 col-sm-3 col-md-3 mx-3"
                    name="" id="">
              <option v-for="(type,index) in searchTypes" :value="index">{{ type }}</option>
            </select>
          </b-row>
        </form>
      </div>
    </div>

    <button pill class="mr-2 btn btn-transparent" @click="openSearchHero()">
      <b-icon class="search-input-1-icon " icon="search"/>
    </button>
  </div>

</template>

<script>
import {searchTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Search'
import router from "@/router";

export default {
  name: "SearchInput",
  data() {
    return {
      words: '',
      type: 'all',
      searchTypes
    }
  },
  methods: {
    openSearchHero() {
      document.getElementById("FullScreenOverlay").style.display = "block";
    },
    closeSearchHero() {
      document.getElementById("FullScreenOverlay").style.display = "none";
    },
    search() {
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    }
  },
  mounted() {


  }
}
</script>

<style scoped>

#FullScreenOverlay {
  animation: fadeIn .5s;
  -webkit-animation: fadeIn .5s;
  -moz-animation: fadeIn .5s;
  -o-animation: fadeIn .5s;
  -ms-animation: fadeIn .5s;
  z-index: 10;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


.openBtn {
  background: #f1f1f1;
  border: none;
  padding: 10px 15px;
  font-size: 20px;
  cursor: pointer;
}

.openBtn:hover {
  background: #bbb;
}

.overlay {
  height: 100%;
  width: 100%;
  display: none;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
}

.overlay-content {
  position: relative;
  top: 38%;
  width: 80%;
  right: 10%;
  text-align: center;
  margin: 30px 0 0 0;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
  cursor: pointer;
  color: white;
}

.overlay .closebtn:hover {
  color: #ccc;
}

.overlay input[type=text] {
  padding: 15px;
  font-size: 17px;
  border: none;
  float: left;
  width: 90%;
  background: white;
}

.overlay input[type=text]:hover {
  background: #f1f1f1;
}

.overlay button {
  float: left;
  width: 20%;
  padding: 15px;
  background: #ddd;
  font-size: 17px;
  border: none;
  cursor: pointer;
}

.overlay button:hover {
  background: #bbb;
}

.SearchHero {
  background: #333333; /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #dd1818, #333333); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #dd1818, #333333); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: #ffffff;
  padding: 20px;
}

.SearchHero p {
  font-size: 13px;
}

.search-input-1-icon {
  color: var(--primary);
  fill: var(--primary) !important;
}

.custom-height {
  height: 50px;
}

</style>